import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import Tooltip from '@/ui/components/Tooltip';

import Card from '../Card';
import Heading from '../Heading';

import type { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const MetricCard = ({
  icon,
  metricName,
  metricValue,
  tooltip,
  iconBg,
  children,
  isActive,
  onClick
}: Props) => {
  if (onClick !== undefined) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`w-full text-left rounded-lg bg-white dark:bg-gray-800 px-3 py-3 shadow-sm ring-1 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
          isActive
            ? 'ring-2 ring-blue-500 bg-blue-50 dark:bg-blue-950'
            : 'ring-gray-200 dark:ring-gray-700 hover:ring-gray-300 dark:hover:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'
        }`}>
        <div className="flex items-center gap-2.5">
          {iconBg && (
            <div className={`hidden md:flex shrink-0 rounded-md ${iconBg} p-2`}>{icon}</div>
          )}
          <div className="min-w-0 flex-1">
            <p className="truncate text-xs font-medium text-gray-500">
              {metricName}{' '}
              {metricValue !== undefined && (
                <span className="text-gray-400 font-normal">({metricValue})</span>
              )}
            </p>
          </div>
        </div>
        {children && <div className="mt-2">{children}</div>}
      </button>
    );
  }

  const heading = tooltip ? (
    <>
      {metricName}{' '}
      <Tooltip tooltipContent={tooltip}>
        <FontAwesomeIcon icon={faQuestionCircle} className="text-gray-500" />
      </Tooltip>
    </>
  ) : (
    metricName
  );

  return (
    <Card className="flex-1">
      <div className="flex flex-col h-full justify-between">
        <Heading value={6} text={heading} />
        <div className="flex items-center justify-between w-full">
          {metricValue}
          {icon}
        </div>
      </div>
    </Card>
  );
};

export default memo(MetricCard);
